import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import './Button.css';

export interface CustomButtonProps extends Omit<MuiButtonProps, 'variant' | 'size'> {
  /**
   * Primary button style (filled) or secondary (outlined/text)
   */
  primary?: boolean;
  
  /**
   * Whether button has a border (only for non-primary buttons)
   */
  bordered?: boolean;
  
  /**
   * Button size
   * - content: Width fits content
   * - regular: Auto width (default)
   * - full: Full width (100%)
   */
  size?: 'content' | 'regular' | 'full';
}

const Button: React.FC<CustomButtonProps> = ({
  primary = true,
  bordered = true,
  size = 'regular',
  className = '',
  sx,
  children,
  ...otherProps
}) => {
  const getClassName = () => {
    const classes = ['button'];
    
    if (primary) {
      classes.push('primary');
    } else if (bordered) {
      classes.push('bordered');
    } else {
      classes.push('text');
    }
    
    classes.push(size);
    
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <MuiButton
      variant={primary ? 'contained' : (bordered ? 'outlined' : 'text')}
      className={getClassName()}
      sx={sx}
      {...otherProps}
    >
      {children}
    </MuiButton>
  );
};

export default Button;
